"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useState, useLayoutEffect } from 'react';
import styles from './ComplexityIndicator.module.scss.mjs';
import { getStatusFromPolicyValidationResult } from '../../lib/getStatusFromPolicyValidationResult.mjs';
import clsx from 'clsx';

const ComplexityIndicator = (props) => {
  const { policyValidationResult, isLoading, isEmptyValue } = props;
  const complexityScore = policyValidationResult?.complexity;
  const [state, setState] = useState({
    percentage: 0,
    status: "success"
  });
  useLayoutEffect(() => {
    let complexityFulfilledPercentage = -1;
    if (policyValidationResult?.isValid === "indeterminate") {
      complexityFulfilledPercentage = 100;
    } else if (complexityScore && !isEmptyValue) {
      complexityFulfilledPercentage = Math.min(
        100 / (complexityScore.min + 1) * (complexityScore.actual + 1),
        100
      );
    }
    const policyValidationStatus = getStatusFromPolicyValidationResult(
      policyValidationResult
    );
    setState({
      status: policyValidationStatus,
      percentage: complexityFulfilledPercentage
    });
  }, [policyValidationResult, isEmptyValue]);
  const complexityVisible = state.percentage !== -1;
  const complexityFulfilled = state.percentage === 100;
  const percentageClassName = clsx(
    styles.bar,
    styles[`bar-background-status-${state.status}`],
    {
      [styles.loading]: isLoading,
      [styles.running]: !complexityFulfilled
    }
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      "aria-hidden": true,
      "data-container": "complexity",
      "data-complexity-visible": complexityVisible,
      "data-complexity-status": state.status,
      "data-complexity-percentage": state.percentage,
      className: clsx(styles.complexityIndicator, {
        [styles.hide]: !complexityVisible
      }),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            width: `${state.percentage}%`
          },
          className: percentageClassName
        }
      )
    }
  );
};

export { ComplexityIndicator, ComplexityIndicator as default };
//# sourceMappingURL=ComplexityIndicator.mjs.map
